import { useCallback, useMemo } from 'react';
import { useQueryParams } from '@shared/hooks/useQueryParams';

export const useShipmentStatusFilters = () => {
  const { params, updateParams } = useQueryParams({
    search: { type: 'string', default: '' },
    courier: { type: 'string', default: 'all' },
    status: { type: 'string', default: 'all' },
  });

  const apiFilters = useMemo(() => {
    const status = params.status;

    let shipment_status_id: number | null | undefined;
    if (status === 'all' || status === 'mapped') {
      shipment_status_id = undefined;
    } else if (status === 'unmapped') {
      shipment_status_id = null;
    } else if (!Number.isNaN(Number(status))) {
      shipment_status_id = Number(status);
    }

    return {
      search: params.search || undefined,
      courier_id: params.courier !== 'all' ? Number(params.courier) : undefined,
      shipment_status_id,
    };
  }, [params.search, params.courier, params.status]);

  const updateFilters = useCallback(
    (updates: { search?: string; courier?: string; status?: string }) => {
      updateParams(updates);
    },
    [updateParams],
  );

  const hasActiveFilters = Boolean(params.search) || params.courier !== 'all' || params.status !== 'all';

  return {
    search: params.search,
    courierId: params.courier,
    statusId: params.status,
    apiFilters,
    updateFilters,
    hasActiveFilters,
  };
};
